import { render, staticRenderFns } from "./asterisk.vue?vue&type=template&id=68c72550&"
import script from "./asterisk.vue?vue&type=script&lang=js&"
export * from "./asterisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports